import React                         from "react";
import {Map}                         from "immutable";
import {PropTypes} from "prop-types";
import T                             from "./t.jsx";
import {EMAIL_REGEXP, displayErrors} from "./validation.jsx";

export const TYPES = ["NAME", "COMPANY", "ADDRESS", "TELEPHONE", "EMAIL", "ORGANIZATION_NUMBER", "SOCIAL_SECURITY_NUMBER", "MOBILE_PHONE_NUMBER"];

const TRANSLATE_PREFIX = "identification-questions.";

/**
 * Props:
 *   type:     string,
 *   onChange: function(string, { text: string, errors: Array<string> })
 *   data:     Map(
 *     "text":   string,
 *     "errors": Array<string>,
 *     "dirty":  boolean
 *   )
 */
class Identification extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = (event) => {
      let text = event.target.value.substr(0, 2044);

      this.props.onChange(this.props.type, Map({
        text:   text,
        errors: this.validate(text),
        dirty:  true
      }));
    };
  }
  validate(text) {
    return text.length === 0 ? ["identification-required"] : [];
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.type !== this.props.type;
  }
  render() {
    return <li className="verification__column">
      <T className="question__title required" component="h4">{TRANSLATE_PREFIX + this.props.type}</T>

      {this.renderInput()}

      {displayErrors(this.props.data)}
    </li>;
  }
  renderInput() {
    return <input type="text" value={this.props.data.get("text")} onChange={this.onChange} />;
  }
}

Identification.propTypes = {
  onChange: PropTypes.func.isRequired,
  type:     PropTypes.oneOf(TYPES)
};

class EmailIdentification extends Identification {
  validate(text) {
    var errors = text.length === 0 ? ["identification-required"] : [];

    if(!EMAIL_REGEXP.test(text) && text.length > 0) {
      errors.push("invalid-email");
    }

    return errors;
  }
  renderInput() {
    return <input type="email" value={this.props.data.get("text")} onChange={this.onChange} />;
  }
}

EmailIdentification.propTypes = {
  onChange: PropTypes.func.isRequired,
  type:     PropTypes.oneOf(["EMAIL"])
};

class AddressIdentification extends Identification {
  renderInput() {
    return <textarea rows="1" value={this.props.data.get("text")} onChange={this.onChange} />;
  }
}

AddressIdentification.propTypes = {
  onChange: PropTypes.func.isRequired,
  type:     PropTypes.oneOf(["ADDRESS"])
};

export const COMPONENTS = [
  { key: "NAME",                   component: Identification },
  { key: "COMPANY",                component: Identification },
  { key: "ORGANIZATION_NUMBER",    component: Identification },
  { key: "SOCIAL_SECURITY_NUMBER", component: Identification },
  { key: "TELEPHONE",              component: Identification },
  { key: "MOBILE_PHONE_NUMBER",    component: Identification },
  { key: "EMAIL",                  component: EmailIdentification },
  { key: "ADDRESS",                component: AddressIdentification }
];
